export default __webpack_public_path__ + "static/media/start-colored.41ff12cc.svg";